import React, { Dispatch, SetStateAction } from 'react'
import { ISelectOption, Select } from 'components/forms/Selects'
import { IFullStop } from 'types'
import { IDetention } from 'apps/detention-review/utils/types'
import { ITimeFormats } from 'apps/fleet-planner/utils/userDateTimeSettings'
import { selectedFacilityAppointmentTime } from '../utils/accessorialHelpers'

interface IFacilitySelectProps {
  detention: IDetention
  onSelect: (values: IDetention) => void
  setSelectedStop: Dispatch<SetStateAction<IFullStop | undefined>>
  stops: IFullStop[]
  timeFormats: ITimeFormats
}

interface IFacilityOptions {
  label: string
  value: string
  name: string
}

interface IIndexedFacilityOptions {
  [key: string]: ISelectOption<IFacilityOptions>
}

const getStopType = (stop: IFullStop): string => {
  return `${stop.type.charAt(0).toUpperCase()}${stop.stopSequence}`
}

const getStopName = (stop: IFullStop): string => {
  return `${stop.facility.city}, ${stop.facility.stateCode}`
}

const getFacilityOptions = (stops: IFullStop[]): IFacilityOptions[] => {
  return stops.map(stop => {
    const stopType = getStopType(stop)
    const stopName = getStopName(stop)
    const label = [stopType, stopName].join(': ')
    const { facility } = stop || {}
    const { shipperFacilityUuid } = facility || {}
    return {
      label,
      value: shipperFacilityUuid,
      name: `${stopName} (${stopType})`,
    }
  })
}

export const FacilitySelect = ({
  detention,
  onSelect,
  setSelectedStop,
  stops,
  timeFormats,
}: IFacilitySelectProps) => {
  const onChange = (option: ISelectOption<any>, id: string) => {
    const { value } = option
    const selectedFacilityStop = stops.find(stop => stop.facility.shipperFacilityUuid === value)
    if (selectedFacilityStop) setSelectedStop(selectedFacilityStop)
    const newState = { ...detention, ...{ [id]: value } }
    onSelect(newState)
  }

  const facilityOptions = getFacilityOptions(stops)

  const indexedFacilityOptions: IIndexedFacilityOptions = facilityOptions.reduce(
    (indexed, fo) => ({ ...indexed, [fo.value]: fo }),
    {}
  )
  const appointmentTime = selectedFacilityAppointmentTime(stops, detention, timeFormats)

  return (
    <div>
      <div className='row'>
        <div className='col-md-12 pl0'>
          <Select
            id='shipperFacilityUuid'
            label='Facility'
            value={indexedFacilityOptions[detention.shipperFacilityUuid]}
            options={facilityOptions}
            onChange={onChange}
          />
        </div>
      </div>
      {detention.shipperFacilityUuid && (
        <div className='row'>
          <div className='col-md-12 pl0'>
            <strong>Appointment </strong>
            <span>{appointmentTime}</span>
          </div>
        </div>
      )}
    </div>
  )
}
